'use strict';

function setChainableConstructor(sugarNamespace, createFn) {
  sugarNamespace.prototype.constructor = function() {
    return createFn.apply(this, arguments);
  };
}

module.exports = setChainableConstructor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/setChainableConstructor.js
// module id = 321
// module chunks = 1